import { render, staticRenderFns } from "./WallOfFame.vue?vue&type=template&id=2302a0db&v-if=isLoggedIn&"
import script from "./WallOfFame.vue?vue&type=script&lang=js&"
export * from "./WallOfFame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports